import { render, staticRenderFns } from "./ChooseBackground.vue?vue&type=template&id=344f3546&scoped=true&"
import script from "./ChooseBackground.vue?vue&type=script&lang=js&"
export * from "./ChooseBackground.vue?vue&type=script&lang=js&"
import style0 from "./ChooseBackground.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ChooseBackground.vue?vue&type=style&index=1&id=344f3546&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344f3546",
  null
  
)

export default component.exports